import './apidocs.css'

const apidocs = () =>{
    return (
        <div>
            <section class="api-integration">
        <div class="container">
            <div class="api-text">
                <h2>Seamless API Integration with SureSend</h2>
                <p>Empower your business with frictionless cross-border payments. 
                   Our robust API connects effortlessly, ensuring secure and scalable transactions.</p>
                <a href="#" class="cta-button">Explore API Docs</a>
            </div>
    
            <div class="api-code">
                <pre>
                    <code>
                        {`fetch('https://api.suresend.com/v1/transfer', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer YOUR_API_KEY'
                            },
                            body: JSON.stringify({
                                amount: 1000,
                                currency: 'USD',
                                recipient: 'john.doe@example.com'
                            })
                        })
                        .then(response => response.json())
                        .then(data => console.log(data))
                        .catch(error => console.error(error));`}
                    </code>
                </pre>
            </div>
        </div>
    </section>
    
        </div>
    )
}


export default apidocs